import React from "react";
import Header from "../components/Header";
import Footer from "../components/Footer";
import Breadcrumb from "../components/Breadcrumb";
import LazyLoad from "react-lazyload";
const OurPrincipal = () => {
  const const_img_path =
    "https://entab-s3-bucket1.s3.ap-south-1.amazonaws.com/SMSMU/public/Images/";

  const principal_list = [
    {
      id: 8,
      name: "Rev. Fr. Reginald D' Souza",
      fromDate: "June 2025",
      toDate: "Onwards",
      img: `${const_img_path}reginald_d_souza.jpg`,
    },
    {
      id: 7,
      name: "Rev. Fr. Jacob Bona D’ Souza",
      fromDate: "July 2020",
      toDate: "June 2025",
      img: `${const_img_path}principal-jacob-bona-02.jpg`,
    },
    {
      id: 6,
      name: "Rev. Fr. Gregory D’souza",
      fromDate: "July 2014",
      toDate: "July 2020",
      img: `${const_img_path}2014–2020.jpg`,
    },
    {
      id: 5,
      name: "Rev. Fr. William Mathias",
      fromDate: "July 2007",
      toDate: "June 2014",
      img: `${const_img_path}2007–2014.jpg`,
    },
    {
      id: 4,
      name: "Late Rev. Fr. Michael D´souza",
      fromDate: "July 2004",
      toDate: "June 2007",
      img: `${const_img_path}2004–2007.jpg`,
    },
    {
      id: 3,
      name: "Late Rev. Fr. Jerome D´souza",
      fromDate: "July 2000",
      toDate: "June 2004",
      img: `${const_img_path}2000–2004.jpg`,
    },
    {
      id: 2,
      name: "Late Rev. Fr. Benedict Periera",
      fromDate: "July 1992",
      toDate: "June 2000",
      img: `${const_img_path}1992–2000.jpg`,
    },
    {
      id: 1,
      name: "Rev. Fr. Sebastian D´cruz",
      fromDate: "July 1989",
      toDate: "June 1992",
      img: `${const_img_path}1989-1992.jpg`,
    },
  ];

  return (
    <>
      <Header />
      <Breadcrumb mid="About" breadcrumbName="Principals" />
      <div className="innerSection">
        <div className="container">
          <div className="row">
            <div className="col-md-12">
              <div className="title">
                <div>
                  <h1>
                    <span>Our </span> Principals
                  </h1>
                </div>
              </div>
            </div>

            {principal_list
              .sort((a, b) => b.id - a.id) // descending order
              .map((principal) => (
                <div
                  key={principal.id}
                  className="col-lg-3 col-md-4 col-sm-6 col-xs-12">
                  <div className="our-principal">
                    <div className="principal-img">
                      <LazyLoad>
                        <img src={principal.img} alt={principal.name} />
                      </LazyLoad>
                    </div>
                    <div className="our-principal-text">
                      <h4>{principal.name}</h4>
                      <h5>{`${principal.fromDate} — ${principal.toDate}`}</h5>
                    </div>
                  </div>
                </div>
              ))}
          </div>
        </div>
      </div>

      <Footer />
    </>
  );
};

export default OurPrincipal;
